import { Component, Input, OnInit } from '@angular/core';
import { DataService } from '../../../../data.service';
import { GeneralService } from '../../../../general.service';
import {TranslateService} from '@ngx-translate/core';
import { SSL_OP_NETSCAPE_CHALLENGE_BUG } from 'constants';
import { Subscription } from 'rxjs';

declare var decimalInput: any;

@Component({
  selector: 'app-fib',
  templateUrl: './fib.html',
  styleUrls: ['./fib.scss']
})

export class FIB implements OnInit {

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public context = "";
  public supplementary = "";  
  public questionId = 0;
  public allClosed = true;

  private loadFIBAnswersSubscription : Subscription;
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) { 
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }

    this.loadFIBAnswersSubscription = this.dataSvc.getLoadFIBAnswersEvent().subscribe(()=>{
      this.loadAnswers();
    });
  }  

  ngOnInit(): void {
    this.loadAnswers();
  }

  loadAnswers() {
    if(this.dataSvc.currentQuestion().Question.QuestionType !== 4) return;
    
    var currentQuestion = this.dataSvc.currentQuestion();
    var keywords = currentQuestion.Question.Question.Keywords.split(',');
    var answers = currentQuestion.Result.Selection.split(',');
    var answerHtml = currentQuestion.Question.QuestionText;

    this.dataSvc.questionSettings.showQuestionText = false
    //prepare answers
    if(answers.length !== keywords.length){
      answers = Array(keywords.length).fill('');
      currentQuestion.Result.Selection = answers.join(',');
    }

    for(let i = 0; i < keywords.length; i++){
      answerHtml = answerHtml.replace("(" + (i + 1).toString() +")", this.getInputHTML(i + 1, answers[i]));
    }

    var dFIBAnswer = document.querySelector('#dFIBAnswer');
    if(dFIBAnswer !== null && dFIBAnswer !== undefined){
      dFIBAnswer.innerHTML = answerHtml;
    }

    //add eventlisteners to inputs - waits until DOM gets updated
    setTimeout(()=> {
      var fibInputs = document.querySelectorAll(".exam-fib-input");
      fibInputs.forEach(fibInput => {
        fibInput.addEventListener('change', (evt) => this.updateFIBAnswers(evt));
      });
    }, 200);
  }

  getInputHTML(keywordNumber, value): string {
    var inputHTML = "";
    
    inputHTML = "<input type='text' class='exam-fib-input' maxlength='100' style='width: 200px;' value='"+value+"' keyword-index='"+keywordNumber.toString()+"'/>";

    return inputHTML;
  }

  updateFIBAnswers(evt){
    var keywordIndex = Number(evt.target.getAttribute("keyword-index"));
    var answers = this.dataSvc.currentQuestion().Result.Selection.split(',');
    answers[keywordIndex - 1] = evt.target.value;

    this.dataSvc.currentQuestion().Result.Selection = answers.join(',');
  }
}
